import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _5cce8e12 = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _06cc530a = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _2d87bd2d = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _c1bd995e = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _8303201e = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _246ef965 = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _32dd2763 = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _3274d37e = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _909152f2 = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _41363ab0 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _25ea717c = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _c8c7b6d8 = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _0fb405cc = () => interopDefault(import('../pages/sale/index.vue' /* webpackChunkName: "pages/sale/index" */))
const _71a5271e = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _4efb3e29 = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _bb14ba58 = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _328784bb = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _32471b9e = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _4281f7ec = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _3ffb592c = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _c626784a = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _506e78be = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _631ff0d6 = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _02958490 = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _5e3a787e = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _1f9c9d32 = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _d278432e = () => interopDefault(import('../pages/sale/output.vue' /* webpackChunkName: "pages/sale/output" */))
const _514154b9 = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _2295fad7 = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _458032f1 = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _42cdadb0 = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _0b9193e5 = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _592340c4 = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _5f884b7c = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _61383b3e = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _132a19e6 = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _76066201 = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _4ac661dd = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _e0fceb7e = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _5d6d4f8f = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _1b58bd0f = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _35a3d45b = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _387d6d04 = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _4b330aa9 = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _18db8128 = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _a7b76c10 = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _7a3c04bc = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _3f4e4bbc = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _8aec4c78 = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _0a89ceb0 = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _57eb7f37 = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _89011502 = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _5a9fb100 = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _9efc961c = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _1d7ad825 = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _ac31ecec = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _76ee3159 = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _29f2ad34 = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _2cadc882 = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _156505aa = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _42b65b8e = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _87419d3e = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _995ab7a8 = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _1e6afce4 = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _1fd21eae = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _d726260c = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _4765b256 = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _23f7cd4d = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _a3cc8ace = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _04674eaf = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _431ea2e4 = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _2db15b8a = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _65fdff44 = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _d7ab2b68 = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _20e811ac = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _115b8808 = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _5cce8e12,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _06cc530a,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _2d87bd2d,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _c1bd995e,
    name: "calendar"
  }, {
    path: "/customer",
    component: _8303201e,
    name: "customer"
  }, {
    path: "/details",
    component: _246ef965,
    name: "details"
  }, {
    path: "/goals",
    component: _32dd2763,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _3274d37e,
    name: "maisoku"
  }, {
    path: "/media",
    component: _909152f2,
    name: "media"
  }, {
    path: "/privacy",
    component: _41363ab0,
    name: "privacy"
  }, {
    path: "/project",
    component: _25ea717c,
    name: "project"
  }, {
    path: "/response",
    component: _c8c7b6d8,
    name: "response"
  }, {
    path: "/sale",
    component: _0fb405cc,
    name: "sale"
  }, {
    path: "/achievement/output",
    component: _71a5271e,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _4efb3e29,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _bb14ba58,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _328784bb,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _32471b9e,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _4281f7ec,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _3ffb592c,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _c626784a,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _506e78be,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _631ff0d6,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _02958490,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _5e3a787e,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _1f9c9d32,
    name: "response-registration"
  }, {
    path: "/sale/output",
    component: _d278432e,
    name: "sale-output"
  }, {
    path: "/setting/announcement",
    component: _514154b9,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _2295fad7,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _458032f1,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _42cdadb0,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _0b9193e5,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _592340c4,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _5f884b7c,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _61383b3e,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _132a19e6,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _76066201,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _4ac661dd,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _e0fceb7e,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _5d6d4f8f,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _1b58bd0f,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _35a3d45b,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _387d6d04,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _4b330aa9,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _18db8128,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _a7b76c10,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _7a3c04bc,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _3f4e4bbc,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _8aec4c78,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _0a89ceb0,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _57eb7f37,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _89011502,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _5a9fb100,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _9efc961c,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _1d7ad825,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _ac31ecec,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _76ee3159,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _29f2ad34,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _2cadc882,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _156505aa,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _42b65b8e,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _87419d3e,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _995ab7a8,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _1e6afce4,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _1fd21eae,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _d726260c,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _4765b256,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _23f7cd4d,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _a3cc8ace,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _04674eaf,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _431ea2e4,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _2db15b8a,
    name: "property-property",
    children: [{
      path: "contact",
      component: _65fdff44,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _d7ab2b68,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _20e811ac,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _115b8808,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
